"use client";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
  const navigate = useNavigate();

  const back = () => {
    navigate("/dashboard");
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <p className="not-found-title">Sorry :(</p>
        <p className="not-found-code">404</p>
        <p className="not-found-subtitle">Page Not Found!</p>
        <p className="not-found-description">
          Oops! The page you’re looking for doesn’t exist or may have been moved.<br /><br />
          But don’t worry - you can get back on track:
        </p>
        <Button
          variant="outlined"
          sx={{ color: '#FFFFFF', borderColor: '#FFFFFF', borderWidth: '1px', mt: 2 }}
          onClick={back}
        >
          Go to Dashboard
        </Button>
      </div>
      <p className="not-found-footer">
        Copyright @2025 eKutir. All rights reserved. Developed By Thinkinfinity Technology And Consulting
      </p>
    </div>
  );
}
